import type React from "react"
import { useId } from "react"
import { useTranslation } from "react-i18next"

import { FormLabel, Stack } from "@mui/material"
import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"

import type { IntervalGranularity } from "./interval-data-selection"

interface IntervalDataGranularityProps {
  granularity: IntervalGranularity
  onGranularityChange: (nextGranularity: IntervalGranularity) => void
}

export const IntervalDataGranularity: React.FC<
  IntervalDataGranularityProps
> = ({ granularity, onGranularityChange }) => {
  const { t } = useTranslation("sites")
  const labelId = useId()

  const handleGranularityChange = (
    _event: React.MouseEvent<HTMLElement>,
    nextGranularity: IntervalGranularity | null
  ) => {
    if (!nextGranularity) {
      return
    }
    onGranularityChange(nextGranularity)
  }

  return (
    <Stack spacing={0.5}>
      <FormLabel id={labelId} sx={{ typography: "caption" }}>
        {t("intervalData.granularity.label")}
      </FormLabel>
      <ToggleButtonGroup
        aria-labelledby={labelId}
        exclusive
        onChange={handleGranularityChange}
        size="small"
        value={granularity}
      >
        <ToggleButton value="as_given">
          {t("intervalData.granularity.asGiven")}
        </ToggleButton>
        <ToggleButton value="day">
          {t("intervalData.granularity.day")}
        </ToggleButton>
        <ToggleButton value="month">
          {t("intervalData.granularity.month")}
        </ToggleButton>
        <ToggleButton value="year">
          {t("intervalData.granularity.year")}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  )
}
